import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBand } from './components/sections/StatsBand';
import { ProblemSection } from './components/sections/ProblemSection';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { WhatsInside } from './components/sections/WhatsInside';
import { Bonuses } from './components/sections/Bonuses';
import { About } from './components/sections/About';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Method } from './components/sections/Method';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-navy-950 font-sans antialiased" data-id="element-0" data-mp="3mlj9mx3nbh44">
      <MetaPixel data-id="element-1" data-mp="3mjg8bgx1m1k3" />
      <main className="w-full" data-id="element-2" data-mp="3rc9d24sih9w6">
        <Hero data-id="element-3" data-mp="3rbzq6q2rjiup" />
        <StatsBand data-id="element-4" data-mp="3rdkg22e4udm8" />
        <ProblemSection data-id="element-5" data-mp="3rd18nfm3z7mg" />
        <BeforeAfter data-id="element-6" data-mp="5yimri0b7dt" />
        <PainPoints data-id="element-7" data-mp="6htxpd5ixiv" />
        <WhatsInside data-id="element-8" data-mp="4n4pyuukj8z" />
        <Bonuses data-id="element-9" data-mp="56m9egl55mh" />
        <About data-id="element-10" data-mp="7st1bvnjh3n" />
        <Testimonials data-id="element-11" data-mp="2zld0746gb58w" />
        <Offer data-id="element-12" data-mp="2zlv3gkrj6jqb" />
        <Guarantee data-id="element-13" data-mp="2zmenc70qri6z" />
        <Method data-id="element-14" data-mp="2zmwlj96ys6hj" />
        <FAQ data-id="element-15" data-mp="2zng1wlgyumtg" />
        <FinalCTA data-id="element-16" data-mp="33mf2jtvnzxf3" />
      </main>
      <Footer data-id="element-17" data-mp="33nq5jrhad155" />
      <FloatingCTA data-id="element-18" data-mp="33n6yj5t6bx5w" />
      <PurchasePopup data-id="element-19" data-mp="33orjc3pos1qk" />
    </div>;
}